export default "__VITE_ASSET__7B5EQCnE__"